import * as React from 'react';
import { Box, Text, TextButton } from '@wix/design-system';
import { FooterLink, FooterLinkCode } from './FooterLink';
import { Brands } from '@wix/package-picker-common';
import { useComponentsTranslations } from '../../providers/ComponentsTranslationsProvider';
import { FooterLogo } from './FooterLogo';
import classNames from 'classnames';
import s from './Footer.scss';
const CopyrightText = ({ brand }) => {
    const { t } = useComponentsTranslations();
    return (React.createElement(Text, { size: "small", weight: "normal", dataHook: "copyright-text" }, t(brand === Brands.EDITOR_X
        ? 'footer.editorx.copyright'
        : 'footer.copyright')));
};
const BackToTopButtonLink = ({ scrollToTop, }) => {
    const { t } = useComponentsTranslations();
    return (React.createElement(TextButton, { size: "small", skin: "dark", onClick: scrollToTop, dataHook: "footer-scroll" }, t('footer.back_to_top')));
};
export const Footer = ({ brand, isLoggedIn, scrollToTop, }) => {
    return isLoggedIn ? (React.createElement("footer", { "data-hook": "footer" },
        React.createElement("div", { className: s.footerInternalWrapper },
            React.createElement("div", { className: classNames(s.footerInternal, brand) },
                React.createElement(FooterLogo, { brand: brand }),
                React.createElement("div", { className: s.footerText },
                    React.createElement("div", { className: s.footerTitle },
                        React.createElement(CopyrightText, { brand: brand })),
                    React.createElement("ul", { className: s.links },
                        Object.values(FooterLinkCode).map((footerLinkCode, i, arr) => {
                            const isLast = i === arr.length - 1;
                            return (React.createElement("li", { key: `footer-link-${i}` },
                                React.createElement(Box, { className: classNames(s.link, {
                                        [s.marginRight]: !isLast,
                                    }) },
                                    React.createElement(FooterLink, { brand: brand, code: footerLinkCode }))));
                        }),
                        scrollToTop && (React.createElement(Box, { marginLeft: "24px" },
                            React.createElement(BackToTopButtonLink, { scrollToTop: scrollToTop }))))))))) : null;
};
//# sourceMappingURL=Footer.js.map